import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateIsEditing = new ReduxAsyncAction<'UPDATE_IS_EDITING', boolean, { isEditing: boolean }>('UPDATE_IS_EDITING');

UpdateIsEditing.registerRequest(async (isEditing: boolean) => {
  return { isEditing };
});

export const UPDATE_IS_EDITING = UpdateIsEditing.actionNamespaceConstants;
export const updateIsEditing = UpdateIsEditing.request;

export type UpdateIsEditingResponseAction = Action<typeof UPDATE_IS_EDITING.response> & {
  data: { isEditing: boolean };
};
